import apiClient from "../apiClient";

import type * as MenuDomain from "@/core/menu/menuDomain";

export enum MenuApi {
	GetMenus = "/admin/menu",
	GetPermissionMenus = "/admin/menu/tree",
	GetAuthorizedMenuIds = "/admin/menu/tree",
	GrantPermission = "/admin/role/menu",
}

const getMenus: MenuDomain.GetMenus = () =>
	apiClient.get({ url: MenuApi.GetMenus });
const getPermissionMenus: MenuDomain.GetPermissionMenus = () =>
	apiClient.get({ url: MenuApi.GetPermissionMenus });
const getAuthorizedMenuIds: MenuDomain.GetAuthorizedMenuIds = (
	roleId: string,
) => apiClient.get({ url: `${MenuApi.GetAuthorizedMenuIds}/${roleId}` });
const grantPermission: MenuDomain.GrantPermission = (data) =>
	apiClient.put({ url: MenuApi.GrantPermission, data });

export default {
	getMenus,
	getPermissionMenus,
	getAuthorizedMenuIds,
	grantPermission,
};
